export interface RespondentProgressModel {
  areAllRespondentsInvited: boolean;
  numberOfRespondents: number;
  numberOfRespondentsComplete: number;
  numberOfRespondentsInvited: number;
  percentageComplete: number;
}
